import React from 'react';
import { connect } from 'react-redux'

import Row from "./row"
import AddRow from "./addRow";

import {selectRow} from "../../actions/index";

const IfEditor = ({ content, sectionName, parentIndex, handleRowSelection, row, parentRowId }) => {
    const ifContent = content.config.if.content;

    return (
        <div style={{border: "dashed 1px lightgray", margin: "2px"}}>
            <div style={{textDecoration: "underline"}}>If block</div>
            <div>{ifContent.map((ifContent, index) => (
                <Row
                    content={ifContent}
                    id={ifContent.id} 
                    selected={row.selected === ifContent.id}
                    onSelection={handleRowSelection}
                    parentIndex={parentIndex}
                    sectionName={sectionName}
                    key={index}
                />
            ))}
            <AddRow allowIf={false} list={ifContent} lastRowId={ifContent.length > 0 ? ifContent[ifContent.length - 1].id : `${parentRowId}if0`}/>
            </div>
        </div>
    );
}

const mapStateToProps = (state) => {
    return { 
        row: state.row
    }
}

const mapDispatchToProps = dispatch => {
    return {
        handleRowSelection: id => {
            dispatch(selectRow(id))
        }
    }
  }

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(IfEditor);